import LegalbirdIoModal from "../../Modal/LegalbirdIoModal";
import ButtonLoading from "../../Button/ButtonLoading";
import React, { useState } from "react";
import ApiClient from "../../../services/ApiClient";

import { ProductUnion } from "../../../types/ProductUnion";

type PowerOfAttorneyModalProps = {
  product: ProductUnion;
  open: boolean;
  handleClose: Function;
  refreshPage?: Function;
};

function PowerOfAttorneyModal({ product, open, handleClose, refreshPage = () => {} }: PowerOfAttorneyModalProps) {
  const [isLoading, setIsLoading] = useState(false);

  const resetContractCase = async () => {
    setIsLoading(true);
    await ApiClient.post(
      "case_special_actions/" + product.productClassName + "/" + product.id + "/reset_power_of_attorney"
    );
    refreshPage();
    handleClose();
    setIsLoading(false)
  };

  return (
    <LegalbirdIoModal
      handleClose={handleClose}
      open={open}
      title={"Vollmacht neu einholen"}
      submitButton={
        <ButtonLoading onClick={resetContractCase} color="primary" variant={"contained"} isLoading={isLoading}>
          Vollmacht neu einholen
        </ButtonLoading>
      }
    >
      <p className={"center"}>
        Möchten Sie die Vollmacht neu von der Mandantschaft einholen? Die Mandanschaft erhält dann automatisch eine
        Anfrage zum Neu-Erteilen der Vollmacht. Die aktuell vorhandene und nicht brauchbare Vollmacht wird entsprechend
        gelöscht.
      </p>
    </LegalbirdIoModal>
  );
}

export default PowerOfAttorneyModal;
